import { render } from "./BannerSobre.vue?vue&type=template&id=54f9ae2e&scoped=true"
import script from "./BannerSobre.vue?vue&type=script&lang=js"
export * from "./BannerSobre.vue?vue&type=script&lang=js"

import "./BannerSobre.vue?vue&type=style&index=0&id=54f9ae2e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f9ae2e"]])

export default __exports__